import { render, staticRenderFns } from "./dental-temps.vue?vue&type=template&id=5a6fcf01&scoped=true&lang=pug"
import script from "./dental-temps.vue?vue&type=script&lang=ts"
export * from "./dental-temps.vue?vue&type=script&lang=ts"
import style0 from "./dental-temps.vue?vue&type=style&index=0&id=5a6fcf01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6fcf01",
  null
  
)

export default component.exports